<template>
  <div class="ag-grid-date">
    <el-date-picker
      ref="agDate"
      v-model="agValue"
      v-bind="componentProps"
      @change="handleChange"
      @focus="handleFocus"
      @blur="handleBlur"
      @keyup.native="handleKeyup"
      @keydown.native="handleKeydown"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { formatDate } from 'element-ui/src/utils/date-util'

import agEditorMixins from './ag-editor-mixins'

export default {
  name: 'AgGridDate',
  mixins: [agEditorMixins],
  props: {
  },
  data() {
    return {
      agValue: ''
    }
  },
  computed: {
    componentProps() {
      return Object.assign(
        {},
        {
          placeholder: this.$t('components.pleaseSelect'),
          valueFormat: 'yyyy-MM-dd',
          format: 'yyyy-MM-dd',
          clearIcon: 'el-icon-circle-close',
          prefixIcon: 'el-icon-date',
          size: 'mini',
          unlinkPanels: false,
          validateEvent: true,
          clearable: true,
          editable: true,
          type: 'date'
        },
        this.params?.cellEditorComponentProps || {}
      )
    }
  },
  mounted() {
    this.$nextTick(() => {
      const { autoFocus, defaultCurrentDate, valueFormat, defaultValue } = this.componentProps

      if (this.params.value) {
        this.agValue = this.params.value
      } else if (defaultCurrentDate) {
        this.agValue = formatDate(new Date(), valueFormat)
      } else if (defaultValue) {
        this.agValue = defaultValue
      }

      if (autoFocus) {
        this.focus()
      }
    })
  },
  methods: {
    triggerChange() {
      const { cellEditorComponentProps, ...restAgParams } = this.params || {}

      const { change } = cellEditorComponentProps || {}

      change?.(this.agValue, { agParams: restAgParams })
    },
    // 监听键盘事件
    handleKeyup(e) {
      this.triggerKeyup(e)
    },
    // 监听键盘事件
    handleKeydown(e) {
      this.triggerKeydown(e)
    },
    handleChange(val) {
      const { datetime } = this.componentProps
      this.agValue = datetime === 'end' ? moment(val).endOf('day')._d : val
      this.triggerChange()
    },
    focus() {
      this.$refs.elInput.focus()
    },
    // 失焦事件
    handleBlur(e) {
      this.triggerBlur(e)
    },
    // 聚焦事件
    handleFocus(e) {
      this.triggerFocus(e)
    }
  }
}
</script>
